export default __webpack_public_path__ + "static/media/robotsmiling.e182d216.png";